exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media (min-width:768px){.collection-style .link{overflow:hidden}.collection-style .link:after{background:rgba(0,0,0,.3);content:\"\\A\";height:100%;left:0;opacity:0;position:absolute;top:0;transition:all .35s;width:100%}.collection-style .link:hover:after{opacity:1}}.collection-style .infos{left:0;top:0;z-index:1}", ""]);

